<template>
  <BaseSlideOutMenu v-model:isOpen="isIndexOpen" :title="$t('brochure.pages')">
    <!-- Brochure index grid -->
    <div class="brochure-index-grid">
      <BrochureIndexItem
        v-for="(spread, index) in spreads"
        :key="index"
        :is-current="
          spread[0]?.index === pagenumber || spread[1]?.index === pagenumber
        "
        class="hide-small"
        @click="goToPage(getPageIndex(spread))"
      >
        <BrochureIndexSpreadItem :spread="spread" />
      </BrochureIndexItem>
      <BrochureIndexItem
        v-for="page in pages"
        :key="page.index"
        :is-current="page.index === pagenumber"
        class="hide-medium-up"
        @click="goToPage(page.index)"
      >
        <BrochureIndexPageItem :page="page" />
      </BrochureIndexItem>
    </div>
  </BaseSlideOutMenu>
</template>

<script setup lang="ts">
import { type PageFragment } from "~/graphql/generated";

const props = defineProps<{
  pages: PageFragment[];
  isIndexOpen: boolean;
}>();

// V-model for the 'close' icon
const emit = defineEmits(["update:isIndexOpen"]);
const isIndexOpen = useVModel(props, "isIndexOpen", emit);

const { pagesToSpreads } = useUtils();
const spreads = pagesToSpreads(props.pages);

const pagenumber = useRouteNumberParam("pagenumber", 0);

const goToPage = (index: number) => {
  isIndexOpen.value = false;
  pagenumber.value = index;
};

const getPageIndex = (spread: [PageFragment | null, PageFragment | null]) => {
  if (spread[0]?.index) return spread[0].index;
  if (spread[1]?.index) return spread[1].index;

  return 0;
};
</script>

<style lang="scss" scoped>
.brochure-index-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
  max-height: 100%;
  overflow-y: auto;
  padding: 0 1rem 1rem 1rem;
}
</style>
